(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ipekciProductCardWishlistObserver) return;

    const expectedPath = 'M6.75 3.75h10.5a1.5 1.5 0 0 1 1.5 1.5v15L12 16.25l-6.75 4v-15a1.5 1.5 0 0 1 1.5-1.5Z';
    const pendingCards = new Set();
    let frameId = 0;

    const normalizeWishlistIcon = (wishlist) => {
      const icon = wishlist.querySelector('svg');
      const path = icon?.querySelector('path');

      if (!icon || !path) return;
      if (path.getAttribute('d') === expectedPath && icon.childElementCount === 1) return;

      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('fill', 'none');
      path.setAttribute('d', expectedPath);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.7');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      icon.replaceChildren(path);
    };

    const moveWishlist = (card) => {
      const row = card.querySelector('.product-card__price-quick-buy');
      const wishlist = card.querySelector('.wishlisthero-floating.wishlist-hero-custom-button, .wishlisthero-floating, .wishlist-hero-custom-button');

      if (!row || !wishlist) return;

      normalizeWishlistIcon(wishlist);
      if (wishlist.parentElement !== row) row.append(wishlist);
    };

    const flush = () => {
      pendingCards.forEach(moveWishlist);
      pendingCards.clear();
      frameId = 0;
    };

    const enqueue = (card) => {
      if (!card) return;
      pendingCards.add(card);
      if (!frameId) frameId = requestAnimationFrame(flush);
    };

    const initialize = (root = document) => {
      if (root.nodeType === Node.ELEMENT_NODE) {
        enqueue(root.matches('product-card') ? root : root.closest('product-card'));
      }

      root.querySelectorAll?.('product-card').forEach(enqueue);
    };

    const start = () => {
      initialize();

      const productRegion = document.getElementById('main');
      if (!productRegion) return;

      window.ipekciProductCardWishlistObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(initialize);
          if (mutation.type === 'attributes') initialize(mutation.target);
        });
      });
      window.ipekciProductCardWishlistObserver.observe(productRegion, {
        attributeFilter: ['d', 'data-prefix'],
        attributes: true,
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
